export default class Preloader {
  // Дефолтный шаблон прелоадера
  static defaultTemplate = `
    <div class="overlay preloader"> 
      <i class="fas fa-2x fa-sync-alt fa-spin"></i> 
    </div>`;

  // Шаблоны прелоадеров
  static templates = {
    default: Preloader.defaultTemplate,
    observerLoader: `
      <span class="spinner--observer"></span>`,
    custom: `
      <div class="overlay preloader"> 
        <div class="custom-loader"></div> 
      </div>`
  };

  static display(type = 'default', target = document.querySelector('.loader')) {
    const template = Preloader.templates[type] || Preloader.defaultTemplate;
    if (target) {
      target.innerHTML = template;
    } else {
      console.warn('Target element not found.');
    }
  }

  static hide(target = document.querySelector('.loader .preloader')) {
    if (target) {
      target.remove();
    }
  }
}